<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <!-- <v-btn large rounded  outlined  color="secondary" class="font-weight-bold" elevation="3"  dark v-on="on">
        {{$t('find in solution selector')}}
      </v-btn> -->

        <v-btn
              rounded
              elevation="3"
              class="white"
              outlined
              color="primary"
              x-large
              :disabled="$store.state.isOffline"
              v-on="on"
            >{{$t('findInSolutionSelector')}}</v-btn>
      <!-- <v-card  v-on="on" height="142">
        <v-container style="width:142px" fill-height fluid>
          <v-layout>
            <span><v-icon class="mx-auto" color="primary">widgets</v-icon>
              {{$t('solutionselector')}}</span>
          </v-layout>
        </v-container>
      </v-card> -->
    </template>
    <v-card tile :disabled="loading">
      <v-toolbar color="primary" dark flat dense class="sticky_solutionSelector">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('solutionselector')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div class="container">
        <div v-if="data" v-show="selectedSolutionId == null">
          <v-toolbar flat dense>
            <v-toolbar-title>{{data.Solutions ? `${$t('selectsolution')}` : `${$t('step')} ${data.Step}: ${data.Title}`}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="data.Selected.length > 0">
              <v-btn
                outlined
                depressed
                small
                v-on:click="prevStep(getPreviousStepIndex())"
                class="mr-2"
              >
                <v-icon color="primary" small>fa-arrow-left</v-icon>
              </v-btn>
              <v-btn small outlined depressed v-on:click="reset()">
                <v-icon color="primary" small>fa-redo</v-icon>
              </v-btn>
            </template>
          </v-toolbar>
          <p>
            <template v-for="(step,i) in selectedTaxonomies">
              <template v-if="step">
                <span :key="i">
                  <a @click="prevStep(i)">{{step}}</a>&nbsp; / &nbsp;
                </span>
              </template>
            </template>
          </p>
          <v-progress-linear @click.stop color="blue darken-2" v-model="data.Selected.length/6*100"></v-progress-linear>
          <div v-if="data.Options">
            <div class="wrapper_options mt-3">
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-avatar-three-line"
                v-for="(tax,i) in data.Options.filter(x => x !== null)"
                :key="i"
              >
                <template v-if="tax !== null">
                  <!-- this should be fixed -->
                  <v-card
                    outlined
                    v-if="data.Options"
                    v-on:click="steps(tax.Id,tax.Name)"
                    class="option wrapper_content_taxonomy"
                  >
                    <div class="option image">
                      <!-- <v-avatar v-if="tax.Image"> -->
                      <v-img aspect-ratio="1" contain height="175"  :src="tax.Image"></v-img>
                      <!-- <img  :src="tax.Image" /> -->
                      <!-- </v-avatar> -->
                    </div>
                    <div class="subtitle-1 font-weight-bold option">{{tax.Name}}</div>
                  </v-card>
                </template>
              </v-skeleton-loader>
            </div>
          </div>
          <div v-else-if="data.Solutions && data.Solutions.length > 0">
            <div class="wrapper_solutions mt-3">
              <v-card
                outlined
                class="wrapper_content_solution"
                v-for="(solution,i) in data.Solutions"
                :key="i"
              >
                <v-img contain :src="solution.Link" height="360px"></v-img>
                <div class="subtitle-1 font-weight-bold solution">{{solution.Name}}</div>
                <v-card-actions>
                  <v-btn
                    small
                    depressed
                    outlined
                    color="primary"
                    v-on:click="selectedSolution(solution)"
                  >{{$t('viewMore')}}</v-btn>
                  <v-btn
                    v-on:click="useInMarker(solution,data.Selected )"
                    small
                    depressed
                    outlined
                    color="secondary"
                  >{{$t('usethisinmarker')}}</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
          <div v-else class="title mt-6 text-center overline mx-auto">{{$t('noresults')}}</div>
        </div>
        <selectedSolutionComponent
          v-on:back="selectedSolutionId = null"
          v-on:useInMarkerFromDetails="useInMarkerFromDetails"
          v-if="selectedSolutionId"
          :id="selectedSolutionId"
          :taxId="tax263415Id"
        ></selectedSolutionComponent>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ajax from "@/services/service.oryx.js";
import selectedSolutionComponent from "@/components/pages/Markers/SolutionSelector/Detail";
import jwtdecode from "jwt-decode";
export default {
  data() {
    return {
      loading: false,
      data: null,
      selectedSolutionId: null,
      tax263415Id: null,
      dialog: false,
      selectedTaxonomies: []
    };
  },
  components: {
    selectedSolutionComponent
  },
  created() {
    this.steps();
    //this.reset();
  },
  methods: {
    selectedSolution(solution) {
      this.selectedSolutionId = solution.Id;
      this.tax263415Id = solution.Tax263415Id;
    },
    useInMarker(solution, taxonomies) {
      this.$emit("selectedSolution", {
        solution: solution,
        taxonomies: taxonomies
      });
      this.dialog = false;
    },
    useInMarkerFromDetails(data) {
      this.$emit("selectedSolution", data);
      this.dialog = false;
    },
    getPreviousStepIndex() {
      let index = this.selectedTaxonomies.length;
      while (index-- && !this.selectedTaxonomies[index]);
      return index;
    },
    prevStep(sliceIndex) {
      if (sliceIndex && sliceIndex !== 0) {
        if (this.data.Selected[sliceIndex] === null) {
          sliceIndex++;
          if (this.data.Selected[sliceIndex] === null) {
            sliceIndex++;
            if (this.data.Selected[sliceIndex] === null) {
              sliceIndex++;
            }
          }
        }
        this.data.Selected = this.data.Selected.slice(0, sliceIndex);
        this.selectedTaxonomies = this.selectedTaxonomies.slice(0, sliceIndex);
      } else {
        this.data.Selected = [];
        this.selectedTaxonomies = [];
      }

      this.steps();
    },
    insertIdinCorrectPosition(id) {
      if (this.data && id !== undefined) {
        this.data.Selected.push(id);
      }
    },
    steps(id, taxname) {
      this.loading = true;
      this.insertIdinCorrectPosition(id);
      //if (this.data) this.data.Selected.push(id);
      const params = {
        taxIds: this.data ? this.data.Selected : [],
        companyId: jwtdecode(localStorage.getItem("auth")).companyId,
        lc: localStorage.getItem("language")
      };

      ajax
        .steps(params)
        .then(res => {
          this.data = res.data;
          this.loading = false;
          if (taxname) this.selectedTaxonomies.push(taxname);
          this.data.Selected.forEach((selected, i) => {
            if (selected == null && this.selectedTaxonomies[i] !== null) {
              this.selectedTaxonomies.splice(i, 0, null);
            }
          });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    reset() {
      this.data = null;
      this.selectedTaxonomies = [];
      this.steps();
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  overflow-y: auto;
}
.wrapper_options {
  --auto-grid-min-size: 20rem;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(
    auto-fill,
    minmax(var(--auto-grid-min-size), 1fr)
  );
}
.wrapper_content_taxonomy {
  /*--auto-grid-min-size: 25rem;*/
  display: grid;

  grid-template-columns: 1fr;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.05);
  border-radius: 1px;
  transition: 0.2s all;
}

.wrapper_options:hover .wrapper_content_taxonomy {
  /* filter:blur(3px); */
  opacity: 0.8;
  transform: scale(0.98);
  box-shadow: none;
}
.wrapper_options:hover .wrapper_content_taxonomy:hover {
  transform: scale(1);
  filter: blur(0px);
  opacity: 1;
  box-shadow: 0 8px 20px 0px rgba(0, 0, 0, 0.125);
}
/* start solutions */
.wrapper_solutions {
  --auto-grid-min-size: 20rem;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(
    auto-fill,
    minmax(var(--auto-grid-min-size), 1fr)
  );
}

.wrapper_content_solution {
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.05);
  border-radius: 1px;
  transition: 0.2s all;
}


.wrapper_solutions:hover .wrapper_content_solution {
  /* filter:blur(3px); */
  opacity: 0.8;
  transform: scale(0.98);
  box-shadow: none;
}
.wrapper_solutions:hover .wrapper_content_solution:hover {
  transform: scale(1);
  filter: blur(0px);
  opacity: 1;
  box-shadow: 0 8px 20px 0px rgba(0, 0, 0, 0.125);
}
/* end solutions */
.option {
  border-radius: 5px;
  padding: 1em;
  height: 100%;
}
.option .image {
  padding: 0;
}
.wrapper_content_taxonomy {
  padding: 0em;
}

.solution {
  border-radius: 5px;
  padding: 1em;
  height: auto;
  min-height: 88px;
}
.sticky_solutionSelector {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0px;
  z-index: 10;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/SolutionSelector/Index.vue